"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NextButton = exports.Container = exports.ModalHeader = void 0;

var _stylitas = require("@creditas/stylitas");

var _button = require("@creditas-lab/button");

var _modal = require("@creditas-lab/modal");

var _styledTools = require("styled-tools");

const ModalHeaderStyled = (0, _stylitas.styled)(_modal.ModalHeader)`
  position: relative;
  z-index: 2;
`;
exports.ModalHeader = ModalHeaderStyled;
const Container = _stylitas.styled.div`
  z-index: 1;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
`;
exports.Container = Container;
Container.Header = _stylitas.styled.div``;
Container.Body = _stylitas.styled.div`
  width: 100%;
`;
Container.Footer = _stylitas.styled.div`
  width: 100%;
  display: flex;
  justify-content: flex-end;
`;
const NextButton = (0, _stylitas.styled)(_button.Button)`
  background: ${(0, _styledTools.theme)('colorNeutral90')};
  width: 60px;
  height: 60px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 16px;
`;
exports.NextButton = NextButton;